// TipTap Table extension wrapper (JS version of the TS file from vuetify-pro-tiptap)
// This mirrors the API shape but removes TypeScript-only syntax.

import { Table as TiptapTable } from '@tiptap/extension-table'
import TableRow from '@tiptap/extension-table-row'
import TableHeader from '@tiptap/extension-table-header'
import TableCell from '@tiptap/extension-table-cell'
import { TableActionButton } from './components/ActionButton'

// If you also create a Vue button component for the toolbar (optional),
// import it here. If you don't have it yet, the `button` option will simply be ignored.
// Example (uncomment after you add the component):
// import TableActionButton from './components/ActionButton.vue'

// Export a Table extension that sets defaults and wires sub-extensions.
const Table = TiptapTable.extend({
  addOptions() {
    // NOTE: `this.parent?.()` calls the underlying Table options if available.
    const parent = this.parent ? this.parent() : {}
    return {
      ...parent,
      resizable: true,
      HTMLAttributes: {
        class: 'table-wrapper',
      },
      // Optional toolbar button integration (only if you provide TableActionButton)
      button: ({ editor, t }) => ({
        component: TableActionButton,
        componentProps: { editor, t },
      }),
    }
  },

  addExtensions() {
    return [
      TableRow.configure(this.options.tableRow || {}),
      TableHeader.configure(this.options.tableHeader || {}),
      TableCell.configure(this.options.tableCell || {}),
    ]
  },
})

export default Table
